import { ISubstatus } from 'src/interfaces/substatus';
import { TSelectItem } from '../components/types';
import { TFunction } from 'src/constants/i18next';

/**
 * Maps the substatuses to a select item
 *
 * @param {ISubstatus[]} substatuses
 */
export const mapSubstatuses = (
    substatuses: ISubstatus[],
    excludedIds: string[],
    selectedStatusIds: string[],
    t: TFunction
): TSelectItem[] => {
    const filtered = substatuses.filter(
        (sub) =>
            !excludedIds.includes(sub._id) &&
            (selectedStatusIds.length === 0 ||
                selectedStatusIds.includes(sub.status))
    );

    return filtered.map((sub) => ({
        value: sub._id,
        label: t(`Substatus.${sub.name}`),
    }));
};
